module.exports = __webpack_public_path__ + "img/PRIO_RECHARGE-nobg.c255c2b8.png";